import { getOperation, putOperation, postAuth } from "utils/api";

export const queryAgent = async (params) => {
  return await getOperation("/agent", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const queryAgentOptions = async (params) => {
  return await getOperation("/agent/options", {
    page: 0,
    size: 500,
    ...params,
  });
};

export const changePassword = async (params) => {
  return await postAuth("/change-password", {
    ...params,
  });
};

export const updateStatus = async (params) => {
  const { isoAgentId, ...rest } = params;
  return await putOperation(`/agent/${isoAgentId}`, {
    ...rest,
  });
};
